export default {
  relevant: "актуально".toUpperCase(),
  always: "всегда".toUpperCase(),
};
